"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.BUTTON_FILL_OPTIONS = exports.BUTTON_COLORS = void 0;
const react_1 = __importDefault(require("react"));
const touch_ripple_1 = require("../../utils/touch-ripple");
const circular_spinner_1 = require("../circular-spinner");
const styles_1 = require("./styles");
exports.BUTTON_COLORS = {
    CANCEL: "cancel",
    DEFAULT: "default",
    PRIMARY: "primary",
    SUCCESS: "success",
};
exports.BUTTON_FILL_OPTIONS = {
    FILLED: "filled",
    OUTLINED: "outlined",
};
const Button = ({ children, color, disabled, fill, loading, ...props }) => {
    return (react_1.default.createElement(styles_1.StyledButton, Object.assign({ color: color !== undefined ? color : exports.BUTTON_COLORS.PRIMARY, disabled: disabled !== undefined ? disabled : false, fill: fill !== undefined ? fill : exports.BUTTON_FILL_OPTIONS.FILLED, isLoading: loading !== undefined ? loading : false }, props),
        loading && (react_1.default.createElement(circular_spinner_1.CircularSpinner, { color: fill == "filled" ? "#FFFFFF" : "primary", size: 16 })),
        children,
        !disabled && !loading && react_1.default.createElement(touch_ripple_1.TouchRipple, null)));
};
exports.Button = Button;
